import { useModalController, useOrderSubmissionErrorModalController } from '@/shared/lib/hooks';
import { modalsService } from '@/shared/lib/modalsService';

export const useDigitalCheckoutModals = () => {
    const invalidEmail = useModalController();
    const invalidPhone = useModalController();
    const orderSubmissionError = useOrderSubmissionErrorModalController();
    const payBoxModal = useModalController();

    modalsService.init({
        onInvalidEmail: invalidEmail.onOpen,
        onInvalidPhone: invalidPhone.onOpen,
        onSubmissionError: orderSubmissionError.onOpen,
        onPayBoxModal: payBoxModal.onOpen,
    });

    return {
        modals: {
            invalidEmail,
            invalidPhone,
            orderSubmissionError,
            payBoxModal,
        },
    };
};
